export default "__VITE_ASSET__DRv2OhXn__"